import MultiAnalyticsModule from 'app/shared/utils/analytics';
import { formatForLog } from 'app/shared/utils/errors';
import type { GaEventObjectType } from 'app/shared/types/GaEventObjectType';

const logger = log.child('analytics/trackEvent');

declare global {
    interface Window {
        dataLayer: any;
    }
}

type GtmEventObjectType = {
    name: string;
};

type AdditionalParamsType = {
    category?: string;
    action?: string;
    label?: string;
    value?: string | number;
    nonInteraction?: boolean;
};

export const trackGtmEvent = (eventObj: GtmEventObjectType) => {
    window.dataLayer.push({ event: eventObj.name });
};

export const trackEvent = (
    gaEventObj: GaEventObjectType,
    additionalParams: Partial<AdditionalParamsType> = {
        category: '',
        action: '',
        label: '',
        value: '',
        nonInteraction: false
    }
) => {
    let ma;

    try {
        ma = MultiAnalyticsModule.getInstance().getMa();
        const category = additionalParams.category || gaEventObj.category;
        const action = additionalParams.action || gaEventObj.action;
        const label = additionalParams.label || gaEventObj.label;
        const value = additionalParams.value || gaEventObj.value;
        const nonInteraction = additionalParams.nonInteraction || gaEventObj.nonInteraction;

        const eventObject: GaEventObjectType = {
            category,
            action,
            label,
            value,
            nonInteraction
        };

        ma.trackEvent(eventObject);
        return;
    } catch (err) {
        logger.error(formatForLog(err), `trackEvent errored out for ${JSON.stringify(gaEventObj)}`);
    }
};
